import React, {useEffect, useState} from "react";
import GenericForm from "Admin/components/GenericForm";
import { GenGet } from "state/api";
import LoadingState from "Admin/components/LoadingState";
import MsgAlert from "Admin/components/MsgAlert";

function CreateAgendamento({initialValues}) {
  const [clienteLoockup, setClienteLookup] = useState([]);
  const [profissionalLoockup, setProfissionalLookup] = useState([]);
  const [servicosLoockup, setServicosLookup] = useState([]);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleLookup = async (endpoint, setter) => {
    try {
      const response = await GenGet(endpoint);
      setter(response)

    } catch (err) {
      setMsg("Erro ao bucar Lookups");    
      setTimeout(() => setMsg(null), 3000);
    }
  };

  useEffect(() => {
    Promise.all([
      handleLookup('/clientes/lookup', setClienteLookup),
      handleLookup('/profissionais/lookup', setProfissionalLookup),
      handleLookup('/servicos/lookup', setServicosLookup)
    ]).then(() => setLoading(false)); 

  }, []);

  if (loading) {
    return (
      <LoadingState />
    )
  }

  return (
    <>
    <GenericForm
      title="Cadastro de Agendamento"
      description="Preencha as informações do agendamento"
      endpoint="/novoagendamento"
      defaultData={initialValues}
      fields={[
        {name: "profissional_id", label: "Profissional", type: "custom-select", options: profissionalLoockup, required: true },
        {name: "cliente_id",label: "Cliente", type: "custom-select", options: clienteLoockup ,required: false, search: true   },
        {name: "servico_produto_id",label: "Serviço", type: "custom-select", options: servicosLoockup, required: true},
        {name: "duracao",label: "Duração (minutos)", type: "number",default: 15 },
        {name: "recorrencia",label: "Recorrência", type: "select", options: [
            { value: "unica", label: "Única" },
            { value: "diaria", label: "Diária" },
            { value: "semanal", label: "Semanal" },
            { value: "quinzenal", label: "Quinzenal" },
            { value: "mensal", label: "Mensal" },
            { value: "trimestral", label: "Trimestral" },
            { value: "semestral", label: "Semestral" },
            { value: "anual", label: "Anual" },
            
          ],default: "unica" },
        { name: "data_hora", label: "Data e Hora",type: "datetime-local", required: true },
        {name: "observacoes",label: "Observações",type: "textarea"},
      ]}
    />
    <MsgAlert alert={msg} />
    </>
  );
}

export default CreateAgendamento;
